import React from 'react';

import { Svg, G, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const KettlebellIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.black.primary,
    ...restProps
  } = props;

  return (
    <Svg width={width} height={height} viewBox="0 0 37 50" {...restProps}>
      <G stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <Path
          d="M24.6753023,0.911271032 C28.2795334,2.12629907 30.781649,3.0505062 31.8461004,7.43661826 C32.9105518,11.8227303 30.735632,17.6183562 30.735632,19.139179 C30.735632,20.1530609 31.1057881,21.0756333 31.8461004,21.906896 C38.6760561,31.2663727 37.7297033,40.2198726 29.0070421,48.7673958 C21.6109722,50.4108681 14.3966581,50.4108681 7.3640998,48.7673958 C-1.34416882,40.8426223 -2.32909605,31.8891224 4.40931809,21.906896 C4.77227867,21.3280443 5.48217732,20.6562804 5.48217732,19.9189215 C5.48217732,19.1815626 2.540904,12.483116 3.6820499,8.12213899 C4.8231958,3.76116201 6.87571027,2.12629907 10.4559487,0.911271032 C14.0361871,-0.303757011 21.0710713,-0.303757011 24.6753023,0.911271032 Z M24.4258156,5.94682623 C21.9263108,4.78065026 14.7280957,4.74598643 12.0861281,5.94682623 C9.44416047,7.14766603 9.16231136,7.60276617 8.75106355,8.80257008 C8.33981573,10.002374 9.24030976,15.2356882 9.87411117,15.9974542 C10.5079126,16.7592203 11.0673645,16.7746684 12.0861281,16.7592203 C13.1048916,16.7437721 14.0469687,15.6559022 18.2437139,15.6559022 C22.440459,15.6559022 23.4249247,16.7592203 24.8806204,16.7592203 C26.079794,16.7437721 26.3604886,16.4835316 26.6111848,15.9974542 C26.8618809,15.5113768 27.5443674,9.80603802 27.2348439,8.80257008 C26.9253204,7.79910215 26.9253204,7.11300221 24.4258156,5.94682623 Z"
          id="Kettlebell"
          fill={color}
        />
      </G>
    </Svg>
  );
};

export default KettlebellIcon;
